import { render, staticRenderFns } from "./TrendingData.vue?vue&type=template&id=5d36d30e&scoped=true&"
import script from "./TrendingData.vue?vue&type=script&lang=js&"
export * from "./TrendingData.vue?vue&type=script&lang=js&"
import style0 from "./TrendingData.vue?vue&type=style&index=0&id=5d36d30e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d36d30e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
